import { css } from "@emotion/react";
// import subscrbe from "@src/assets/subscription/subscribe.svg";
// import subscrbeV2 from "@src/assets/subscription/subscribeV2.svg";
// import stateLand from "@src/assets/subscription/stateLand.svg";
// import stateLandV2 from "@src/assets/subscription/stateLandV2.svg";
// import goStop from "@src/assets/subscription/goStop.svg";
// import roadPlanV2 from "@src/assets/subscription/roadPlanV2.svg";
// import roadPlan from "@src/assets/subscription/roadPlan.svg";
// import storeGoStop from "@src/assets/subscription/storeGoStop.svg";
// import storeGoStopV2 from "@src/assets/subscription/storeGoStopV2.svg";
// import goStopV2 from "@src/assets/subscription/goStopV2.svg";

import VVIP from "@src/assets/subscription/VVIP.png";
import VIP from "@src/assets/subscription/VIP.png";
import LITE from "@src/assets/subscription/LITE.png";
import Basic from "@src/assets/subscription/BASIC.png";

import React from "react";
import { useState } from "react";
import { getDeviceType } from "@src/lib/WebAppBridge";
import { useSearchParams } from "react-router-dom";

interface Props {
    stickyRef?: any;
    onScroll: (refId: string) => void;
    isFocus: string;
}

const SubscriptionSticky: React.FC<Props> = ({ stickyRef, onScroll, isFocus }) => {
    const [searchParams] = useSearchParams();
    const stickyList = [
        {
            keyId: "aosAuction",
            id: "topRef",
            title: "VVIP\nFull",
            imgSrc: VVIP,
            clickImg: VVIP,
        },
        {
            keyId: "aosStateLand",
            id: "landRef",
            title: "VIP\nFull",
            imgSrc: VIP,
            clickImg: VIP,
        },
        // {
        //     keyId: "aosPremiumFilter",
        //     id: "goStopRef",
        //     title: "VIP\nLite",
        //     imgSrc: LITE,
        //     clickImg: LITE,
        // },
        {
            keyId: "aosStoreGoStop",
            id: "storeGoStopRef",
            title: "베이직",
            imgSrc: Basic,
            clickImg: Basic,
        },
    ];

    const iosStickyList = [
        {
            keyId: "iosAuction",
            id: "topRef",
            title: "VVIP\nFull",
            imgSrc: VVIP,
            clickImg: VVIP,
        },
        {
            keyId: "iosStateLand",
            id: "landRef",
            title: "VIP\nFull",
            imgSrc: VIP,
            clickImg: VIP,
        },
        // {
        //     keyId: "iosPremiumFilter",
        //     id: "goStopRef",
        //     title: "VIP\nLite",
        //     imgSrc: LITE,
        //     clickImg: LITE,
        // },
        {
            keyId: "iosStoreGoStop",
            id: "storeGoStopRef",
            title: "베이직",
            imgSrc: Basic,
            clickImg: Basic,
        },
    ];

    return (
        <div ref={stickyRef} css={stickyBox}>
            {iosStickyList && stickyList && searchParams.get("type") === "6"
                ? stickyList.map((list) => {
                      return (
                          <div
                              key={list.keyId}
                              onClick={() => {
                                  onScroll(list.id);
                              }}
                              style={{
                                  color: isFocus === list.id ? "#000" : "#000",
                                  backgroundColor: isFocus === list.id ? "#FFF" : "#FFF",
                                  border: isFocus === list.id ? "2px solid #0047FF" : "2px solid transparent",
                                  boxSizing: "border-box",
                              }}
                              className="contentBox"
                          >
                              <div className="imgBox">
                                  <img src={isFocus === list.id ? list.clickImg : list.imgSrc} alt="" />
                              </div>
                              <p>{list.title}</p>
                          </div>
                      );
                  })
                : iosStickyList.map((list) => {
                      return (
                          <div
                              key={list.keyId}
                              onClick={() => {
                                  onScroll(list.id);
                              }}
                              style={{
                                  color: isFocus === list.id ? "#000" : "#000",
                                  backgroundColor: isFocus === list.id ? "#FFF" : "#FFF",
                                  border: isFocus === list.id ? "3px solid #1672FF" : "3px solid transparent",
                                  boxSizing: "border-box",
                              }}
                              className="contentBox"
                          >
                              <div className="imgBox">
                                  <img src={isFocus === list.id ? list.clickImg : list.imgSrc} alt="" />
                              </div>
                              <p>{list.title}</p>
                          </div>
                      );
                  })}
        </div>
    );
};

export default SubscriptionSticky;

const stickyBox = css`
    width: 100%;
    position: sticky;
    z-index: 2;
    top: 0px;
    gap: 5px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    background-color: #fbf8f8;
    padding: 12px 14px;

    .contentBox {
        white-space: pre-wrap;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 70px;
        height: 110px;
        border-radius: 8px;
        cursor: pointer;
        font-size: 12px;

        .imgBox {
            height: 50px;
            img {
                max-width: 60px;
            }
        }

        & > p {
            text-align: center;
        }
    }
`;
